<template>
  <div class="wrapper-diagram">
    <div class="list">
      <div class="list__item">
        <div class="list__item_name-wrapper">
        </div>
        <div class="list__item-number">
          <span>MSV</span>
        </div>
        <div class="list__item-number">
          <span>KW #</span>
        </div>
      </div>
      <div class="list__item" v-for="item in vennDiagramConfig.legends"
           :key="item.label">
        <div class="list__item_name-wrapper">
          <span class="list__item-color" :style="getItemColorClass(item.color)"></span>
          <span class="list__item-name" :title="item.label">{{item.label}}</span>
        </div>
        <div class="list__item-number">
          <span>{{item.size | roundNumber | commaDividedNumber}}</span>
        </div>
        <div class="list__item-number">
          <span>{{item.keywords | roundNumber | commaDividedNumber}}</span>
        </div>
      </div>
    </div>
    <div style="margin-left: 10px">
      <BaseVennDiagram
        :config="vennDiagramConfig"/>
    </div>
  </div>
</template>

<script>
import filters from '@/common/Filters'
import BaseVennDiagram from '../../../common/BaseVennDiagram'

const colors = ['#88e276', '#ff6c6c', '#ffbc5b', '#9aaaff']
/**
 * Component with custom report table and Venn diagramm {@link BaseVennDiagram}
 */
export default {
  name: 'VennDiagram',
  props: {
    config: {
      required: true
    },
    customReport: {
      required: true
    }
  },
  computed: {
    /**
     * prepare venn diagram config according to "venn.js" library requirements
     */
    vennDiagramConfig () {
      let index = 0
      const config = {
        ...this.config,
        sets: this.config.sets.map((item) => {
          if (item.sets.length === 1) {
            item.color = colors[index]
            index++
          }
          return item
        })
      }
      config.legends = config.sets
        .filter(item => item.sets.length === 1)
        .sort((a, b) => {
          return b.size - a.size
        })

      config.legends.push({
        label: this.customReport.label,
        color: '#000',
        keywords: this.customReport.keywords || 0,
        size: this.customReport.msv || 0
      })

      return config
    }
  },
  methods: {
    getItemColorClass (color) {
      return { 'background-color': color }
    }
  },
  filters: {
    roundNumber: filters.roundNumber,
    commaDividedNumber: filters.commaDividedNumber
  }

}
</script>

<style scoped lang="scss">

  .wrapper-diagram {
    display: flex;
    width: 100%;
    justify-content: space-around;
  }

  .list {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__item {
      display: flex;
      //justify-content: space-between;
      height: 30px;
      align-items: center;
      font-size: 12px;
      font-weight: 500;
      color: $rfx-dark-march;

      &-color {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        display: inline-block;
        margin: 0 10px 1px 0;
        flex-shrink: 0;
      }

      &-number {
        min-width: 70px;
        display: flex;
        font-size: 12px;
        flex: 1;
        justify-content: flex-end;
        //padding-left: 15px;
      }

      &-name {
        font-size: 13px;
        font-weight: 500;
        @include ellipsis
      }

      &_name-wrapper {
        height: 100%;
        display: flex;
        align-items: center;
        //max-width: 360px;
        overflow: hidden;
        flex: 2;
      }

      &:last-child {
        margin-top: 10px;
      }
    }
  }

</style>
